import * as GOVUKFrontend from 'govuk-frontend';
window.GOVUKFrontend = GOVUKFrontend;

require('hmpo-components/all');

window.GOVUKFrontend.initAll();
